import { render, staticRenderFns } from "./FileLink.vue?vue&type=template&id=514c7592&"
import script from "./FileLink.vue?vue&type=script&lang=js&"
export * from "./FileLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports